// Plugins
import router from '@/router'
import store from "@/store";
import vuetify from './vuetify'
import Helper from './Helper'
import moment from "./moment";
import i18n from './vue-i18n'



export function registerPlugins(app) {
  app.use(router)
  app.use(store)
  app.use(vuetify)
  app.use(Helper)
  app.use(i18n)
  app.use(moment)
}
